class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');
    this.hideButton = this.querySelector('button#hide_search');

    this.searchIconButton = document.querySelector('button#search-icon-button');
    this.searchHeader = document.querySelector('header-search');

    this.onEscape = this.onEscape.bind(this);
    this.toggleSearch = this.toggleSearch.bind(this);
    this.closeSearch = this.closeSearch.bind(this);
    this.openSearch = this.openSearch.bind(this);
    this.positionUnderHeader = this.positionUnderHeader.bind(this);

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
    if (this.searchIconButton) {
      this.searchIconButton.addEventListener('click', this.toggleSearch);
    }
    if (this.hideButton) {
      this.hideButton.addEventListener('click', this.closeSearch);
    }
  }

  toggleSearch() {
    if (!this.searchHeader) return;

    if (this.searchHeader.classList.contains('hidden')) {
      this.openSearch();
    } else {
      this.closeSearch();
    }
  }

  positionUnderHeader() {
    if (!this.searchHeader) return;

    const headerMain = document.querySelector('#header__main');
    const top = headerMain ? Math.round(headerMain.getBoundingClientRect().bottom) : 0;
    this.searchHeader.style.setProperty('--search-panel-top', `${top}px`);
  }

  openSearch() {
    if (!this.searchHeader) return;

    this.positionUnderHeader();
    this.searchHeader.classList.remove('hidden');
    this.searchIconButton?.setAttribute('aria-expanded', 'true');
    document.addEventListener('keydown', this.onEscape);
    window.addEventListener('resize', this.positionUnderHeader);
    window.addEventListener('scroll', this.positionUnderHeader, { passive: true });

    this.input?.focus();
  }

  closeSearch(options = {}) {
    if (!this.searchHeader) return;
    if (this.searchHeader.classList.contains('hidden')) return;

    document.removeEventListener('keydown', this.onEscape);
    window.removeEventListener('resize', this.positionUnderHeader);
    window.removeEventListener('scroll', this.positionUnderHeader);
    this.searchHeader.classList.add('hidden');
    this.searchHeader.style.removeProperty('--search-panel-top');
    this.searchIconButton?.setAttribute('aria-expanded', 'false');
    if (options.restoreFocus !== false) {
      this.searchIconButton?.focus();
    }
  }

  onEscape(event) {
    if (event.key === 'Escape' || event.code === 'Escape') {
      event.preventDefault();
      this.closeSearch();
    }
  }

  toggleResetButton() {
    if (!this.resetButton || !this.input) return;

    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm() && this.input) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);
